import { render, staticRenderFns } from "./concept3.vue?vue&type=template&id=a69228ca&scoped=true&"
import script from "./concept3.vue?vue&type=script&lang=js&"
export * from "./concept3.vue?vue&type=script&lang=js&"
import style0 from "./concept3.vue?vue&type=style&index=0&id=a69228ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69228ca",
  null
  
)

export default component.exports